import { QFilterGeneric } from './QFilterGeneric'

export class QFilterSearch extends QFilterGeneric {
  name = "search";
  class_name = "QFilterSearch";
  api_name = 'search';

  chip_object() {
    return {
      value: this.value,
      name: this.name,
      readable: 'Búsqueda',
      component: this.chip_component
    };
  }

}
